import React, { useEffect, useState } from 'react'
import { Button, Loader, Modal} from 'semantic-ui-react'
import agent from '../../app/api/agent';
import ShippingReceipt from './ShippingReceipt';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { uploadFileType } from '../../app/api/types';
import { useStore } from '../../app/stores/store';
import { historyInitialState } from '../../app/models/history';

interface ReceiptModalProps {
    isModal: boolean;
    setIsModal: (value: boolean) => void;
    data:any
}


const ReceiptModal:React.FC<ReceiptModalProps> = ({isModal, setIsModal, data}) => {
    const[selected, setSelected]=useState<any>({})
    const{ElementStore, activityStore, userStore} = useStore();
    const[isLoading, setIsLoading]=useState(false)
    useEffect(() => {
        if(data.id){
        const fetchData = async () => {
          try {
            const res = await agent.HFC.HFCShippingAssetReceipt(data.id);
            const selectedData = res.data;
            setSelected(selectedData);
          } catch (err) {
            console.log(err)
          }
        };
    
        fetchData();
    }
      }, [data.id]);

      const addToItemFiles = async (blobFile: Blob, fileName: string,data:any) => {
        setIsLoading(true)
        let response;
        let addFilesPayload: uploadFileType = { id: '', files: [] };
        var file = new File([blobFile], fileName);
       
          response = await agent.Files.uploadFile(file);
          addFilesPayload = {
            id:data.id,
            files: [{ ...response.data, addedOn: new Date() }],
          };
        await ElementStore.HFCgeneratePdf(addFilesPayload);
        await agent.HFC.HFCShippingAsset(data.id, selected.order_ID)
        await activityStore.HFCShippingdeliveryloadActivitiesPagination (1, "",5)
        const payload = {
          ...historyInitialState,
          itemId: data.asset_ID,
          status: `${userStore.user?.displayName} has successfully shipped the asset "${data.title}"`,
          dateTime: new Date().toISOString(),
          trackerFromTime: new Date().toISOString()
        }
        await agent.HFC.HFCaddHistory(payload);
        setIsLoading(false)
        setIsModal(false)
      };
    

  return (
    <Modal open={isModal}
    onClose={() => setIsModal(false)}
    onOpen={() => setIsModal(true)}><Modal.Header>Shipping Receipt</Modal.Header>
        <Modal.Content>
            <ShippingReceipt data={data} selected={selected} pdfViewerProps={true}/>
        </Modal.Content>
        <Modal.Actions>  
        <PDFDownloadLink document={<ShippingReceipt data={data} selected={selected} pdfViewerProps={false}/>} fileName={`ShippingReceipt-${selected.asset_ID}.pdf`}>
            {({ blob, url, loading, error }) =>
            <Button 
            primary 
            disabled={isLoading} 
            onClick={() => addToItemFiles(blob!, `ShippingReceipt_${selected.asset_ID}`, data)}
          >
            {isLoading && <Loader active inline size='tiny'/>} Download Receipt
          </Button>
          }
        </PDFDownloadLink>
        </Modal.Actions>
    </Modal>
  )
}

export default ReceiptModal